import React, {Component} from "react"

import History from "@irati/utils/history"
import Loading from "@irati/ui/src/Loading"
import userService from "@irati/identity/services/users"
import onboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"
import {User} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import authentication from "@irati/auth"
import passwordService from "@irati/auth/services/password"
import loginService from "@irati/auth/services/login"
import FormattedMessage from "@irati/utils/lang"

import tracking from "@irati-tracking/platform/platform"
import SetPassword, {HandleSetPassword} from "../../components/UserOnboarding/SetPassword"
import {getQuery} from "../../helpers/getOnboardingQuery"

interface Props {}

interface State {
  load: Promise<any>
  user: User | null
}

class UserOnboarding extends Component<Props, State> {
  state: State = {
    load: hangPromise(),
    user: null
  }

  componentDidMount() {
    this.setState({
      load: this.getUser()
    })
  }

  getUser = () => {
    const {uuid} = getQuery()
    const {showPasswordLogin} = authentication.unAuthedBusiness()
    if (!showPasswordLogin) {
      return History.push({pathname: "/"})
    }
    return userService.unAuthedUser(uuid).then((user: User) => {
      return onboardingService.get(user.uuid).then(({steps, completedSteps}) => {
        if (completedSteps.includes(OnboardingStep.SET_PASSWORD)) {
          History.push({pathname: "/"})
        }
        tracking.enterPassword()
        this.setState({user})
        return {steps}
      })
    })
  }

  handleSetPassword: HandleSetPassword = (password) => {
    const {code} = getQuery()
    const user = this.state.user!
    return loginService.logout({redirectOnLogout: false}).then(() => {
      return passwordService.setForgot(user.uuid, code, password).then(() => {
        return loginService.login(authentication.unAuthedBusiness(), user.email, password).then(() => {
          return onboardingService.completeStep(user, OnboardingStep.SET_PASSWORD).then(() => {
            tracking.successCreatePassword()
            tracking.loginSuccess("onboarding")
            History.push({pathname: "/"})
          })
        })
      })
    })
  }

  render() {
    const {load, user} = this.state

    const header = <FormattedMessage id="onboarding.validateDetails.data.header1" values={{firstname: user?.firstName}} />

    return (
      <Loading load={load}>
        <SetPassword user={user} onComplete={this.handleSetPassword} header={header} />
      </Loading>
    )
  }
}

export default UserOnboarding
